var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"camera-feed"},[_c('video',{ref:"video",attrs:{"playsinline":"","autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }